export default "__VITE_ASSET__f5816122__"